import { Construction } from 'lucide-react';

interface ComingSoonProps {
  title: string;
}

export function ComingSoon({ title }: ComingSoonProps) {
  return (
    <div className="bg-gradient-page flex h-full items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="bg-accent-100 flex h-16 w-16 items-center justify-center rounded-2xl">
          <Construction className="text-accent-main h-8 w-8" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold">{title}</h1>
          <p className="text-muted-foreground mt-1 text-sm">
            This feature is coming soon. Stay tuned!
          </p>
        </div>
      </div>
    </div>
  );
}
